import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
export default {
    name: "google-maps",
    props: {
        address: String,
        locations: {
            type: Array[Object],
            required: false
        },
        zoom: {
            type: Number,
            default: 16
        }
    },
    data: function data() {
        return {
            map: null,
            marker: null,
            geoCoder: null,
            newAddress: '',
            longitude: -77.036526,
            latitude: -12.062106,
            timeout: null
        };
    },

    watch: {
        address: function address() {
            var _this = this;

            clearTimeout(this.timeout);
            this.timeout = setTimeout(function () {
                return _this.changeAddress();
            }, 1500);
        }
    },
    methods: {
        createComponent: function createComponent(createElement) {
            return this.createContainer(createElement);
        },
        createContainer: function createContainer(createElement) {
            return createElement('div', {
                class: ['embed-google-maps'],
                style: {},
                ref: 'gmap'
            }, []);
        },
        createMap: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var location;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                location = { lat: this.latitude, lng: this.longitude };

                                this.createMapInstance(location);
                                _context.next = 4;
                                return this.changeAddress();

                            case 4:
                                this.createMarkerInstance(location);
                                this.createMapEvents();

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function createMap() {
                return _ref.apply(this, arguments);
            }

            return createMap;
        }(),
        createMapEvents: function createMapEvents() {
            var _this2 = this;

            this.map.panTo(this.marker.getPosition());
            this.marker.addListener('drag', function (evt) {
                var location = { lat: evt.latLng.lat(), lng: evt.latLng.lng() };
                _this2.changeCoordinates(evt.latLng.lat(), evt.latLng.lng());
                _this2.getPlusCodeFromLocation(location);
            });
            this.marker.addListener('dragend', this.draggableEvent);
        },
        createMapInstance: function createMapInstance(location) {
            var Map = window.google.maps.Map;
            this.map = new Map(this.$refs["gmap"], {
                disableDefaultUI: true,
                center: location,
                zoom: this.zoom
            });
        },
        createMarkerInstance: function createMarkerInstance(location) {
            var MapMakerInstance = window.google.maps.Marker;
            this.marker = new MapMakerInstance({
                map: this.map,
                draggable: true,
                position: location
            });
        },
        draggableEvent: function draggableEvent() {
            var location = { lat: this.latitude, lng: this.longitude };
            this.map.setCenter(location);
        },
        changeAddress: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                var _this3 = this;

                var Geocoder;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                Geocoder = window.google.maps.Geocoder;

                                this.geoCoder = new Geocoder();
                                _context2.next = 4;
                                return this.geoCoder.geocode({ "address": this.address }, function (results, status) {
                                    if (status === "OK") {
                                        var result = results[0];
                                        var location = result.geometry.location;
                                        var locationObj = { lat: location.lat(), lng: location.lng() };

                                        // Probando resultados
                                        // console.warn(result);

                                        // PLUS CODE solo existe cuando tienes completos los datos del lugar
                                        // Si no llenas todos los campos obligatorios, el plusCode sera nulo
                                        // Comportamiento por defecto de Google
                                        _this3.changeCoordinates(locationObj.lat, locationObj.lng);
                                        _this3.map.setCenter(locationObj);
                                        _this3.marker.setPosition(locationObj);
                                        _this3.changeAddressEvent(result.formatted_address, result.plus_code ? result.plus_code.compound_code : null, locationObj.lat, locationObj.lng);
                                    } else {
                                        console.error('Geocode was not successful for the following reason: ' + status); // DEV
                                    }
                                });

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function changeAddress() {
                return _ref2.apply(this, arguments);
            }

            return changeAddress;
        }(),

        // Consulta de los datos mediante longitud y latitud, necesaria para el drag en el mapa
        getPlusCodeFromLocation: function getPlusCodeFromLocation(location) {
            var _this4 = this;

            this.geoCoder.geocode({ location: location }, function (results, status) {
                if (status === 'OK') {
                    console.warn(results);
                    var firstChild = results[0];
                    if (firstChild) {
                        var geometry = firstChild.geometry.location;
                        var plusCode = firstChild.plus_code ? firstChild.plus_code.compound_code : null;
                        var _location = { lat: geometry.lat(), lng: geometry.lng() };
                        _this4.newAddress = firstChild.formatted_address;

                        _this4.map.setCenter(_location);
                        _this4.marker.setPosition(_location);
                        _this4.changeAddressEvent(_this4.newAddress, plusCode, _location.lat, _location.lng);
                    }
                }
            });
        },
        changeCoordinates: function changeCoordinates(latitude, longitude) {
            this.latitude = latitude;
            this.longitude = longitude;
        },
        changeAddressEvent: function changeAddressEvent(address, plusCode, latitude, longitude) {
            // Comentado hasta que el sistema funcione, plusCode es un sistema de geocodificacion
            // para identificar cualquier parte de la tierra, mas sencillo que utilizando
            // longitud y latitud, en teoria deberia existir en todas las partes
            // pero en ocaciones Google retorna nulo
            this.$emit("changeAddress", { address: address, plusCode: plusCode, latitude: latitude, longitude: longitude });
            // console.warn({ address, plusCode: null, latitude, longitude });
        }
    },
    mounted: function mounted() {
        var _this5 = this;

        this.$nextTick(function () {
            return _this5.$nextTick(function () {
                return _this5.createMap();
            });
        });
    },
    render: function render(createElement) {
        return this.createComponent(createElement);
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/google-maps.js
// module id = ./src/components/shared/google-maps.js
// module chunks = 34